"use client";

import { createPortal } from "react-dom";
import { useToast } from "@/hooks/use-toast";
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast";
import { cn } from "@/lib/utils";
import IcSuccess from "@/assets/icons/ic-toast-success.svg";
import IcFail from "@/assets/icons/ic-toast-fail.svg";

const positionClasses: Record<string, string> = {
  "bottom-center": "fixed bottom-4 left-1/2 -translate-x-1/2 z-[100]",
  "bottom-left": "fixed bottom-4 left-4 z-[100]",
  "top-left": "fixed top-4 left-4 z-[100]",
  "bottom-right": "fixed bottom-4 right-4 z-[100]",
  "top-center": "fixed top-4 left-1/2 -translate-x-1/2 z-[100]",
  "top-right": "fixed top-4 right-4 z-[100]",
};

export function Toaster() {
  const { toasts } = useToast();

  return createPortal(
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, variant, position, ...props }) {
        const isDestructive = variant === "destructive";
        return (
          <Toast
            key={id}
            variant={variant}
            className={cn(
              positionClasses[position ?? "top-right"],
              "w-[calc(100vw-32px)] sm:max-w-[350px] lg:max-w-[420px]",
              // On mobile: override to center horizontally
              !position && "max-sm:left-1/2 max-sm:right-auto max-sm:-translate-x-1/2",
            )}
            {...props}
          >
            {isDestructive ? <img src={IcFail} alt="" /> : <img src={IcSuccess} alt="" />}
            <div className="flex-1 flex flex-col gap-0.5">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && <ToastDescription>{description}</ToastDescription>}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>,
    document.body,
  );
}
